<template>
  <div class="d-inline-flex vertical-align-middle" @click.stop>
    <label class="switch">
      <input v-model="switchValue" type="checkbox" :disabled="disabled" />

      <span class="slider round" :class="{ 'is-on': switchValue, 'with-icons': withIcons }">
        <!-- Knob -->
        <span class="slider-knob"></span>

        <!-- Checkmark (ON) -->
        <span v-if="withIcons" class="slider-icon slider-icon--on">
          <span class="icon-line icon-line--check-1"></span>
          <span class="icon-line icon-line--check-2"></span>
        </span>

        <!-- Cross (OFF) -->
        <span v-if="withIcons" class="slider-icon slider-icon--off">
          <span class="icon-line icon-line--cross-1"></span>
          <span class="icon-line icon-line--cross-2"></span>
        </span>
      </span>

      <span v-if="title" class="title">{{ title }}</span>
    </label>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'SwitchItem',
    props: {
      modelValue: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: '',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      withIcons: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['update:modelValue'],
    computed: {
      switchValue: {
        get() {
          return this.modelValue
        },
        set(val: boolean) {
          this.$emit('update:modelValue', val)
        },
      },
    },
  })
</script>

<style scoped lang="scss">
  .switch {
    position: relative;
    display: inline-flex;
    align-items: center;
    min-width: 40px;
    height: 24px;

    input {
      position: absolute;
      opacity: 0;
      width: 0 !important;
      height: 0 !important;
    }

    .title {
      margin-left: 8px;
      color: var(--color-text-grey);
      white-space: nowrap;
    }
  }

  /* TRACK */
  .slider {
    position: relative;
    width: 40px;
    height: 24px;
    background-color: var(--color-background-grey-3); // OFF
    cursor: pointer;
    transition: background-color 0.25s ease;

    &.round {
      border-radius: 999px;
      max-width: 40px;
    }

    &.is-on {
      background-color: var(--color-light-orange); // ON
    }
  }

  /* KNOB */
  .slider-knob {
    position: absolute;
    top: 4px;
    left: 4px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: var(--color-white);
    transition: transform 0.25s ease;
    z-index: 2; // кружок завжди зверху
  }

  .switch input:checked + .slider .slider-knob {
    transform: translateX(16px);
  }

  .switch input:focus-visible + .slider {
    outline: 2px solid var(--color-light-orange);
    outline-offset: 2px;
  }

  /* ICONS CONTAINER */
  .slider-icon {
    position: absolute;
    top: 7px;
    width: 10px;
    height: 10px;
    pointer-events: none;
    z-index: 1;
  }

  /* ON: галочка ліворуч */
  .slider-icon--on {
    left: 6px;
    opacity: 0;
    transition: opacity 0.15s ease;
  }

  /* OFF: хрестик праворуч */
  .slider-icon--off {
    right: 6px;
    opacity: 1;
    transition: opacity 0.15s ease;
  }

  /* показуємо потрібну іконку залежно від стану */
  .slider.is-on .slider-icon--on {
    opacity: 1;
  }
  .slider.is-on .slider-icon--off {
    opacity: 0;
  }

  /* ЛІНІЇ ДЛЯ ІКОНОК */
  .icon-line {
    position: absolute;
    border-radius: 1px;
  }

  /* CHECKMARK = дві білі лінії */
  .slider-icon--on .icon-line {
    background-color: var(--color-white);
  }

  .icon-line--check-1 {
    width: 2px;
    height: 4px;
    left: 2px;
    top: 5px;
    transform: rotate(130deg);
  }

  .icon-line--check-2 {
    width: 2px;
    height: 7px;
    left: 5px;
    top: 1px;
    transform: rotate(210deg);
  }

  /* CROSS = дві темно-сірі лінії */
  .slider-icon--off .icon-line {
    background-color: #4a4a4a;
  }

  .icon-line--cross-1 {
    width: 2px;
    height: 9px;
    top: 1px;
    left: 4px;
    transform: rotate(45deg);
  }

  .icon-line--cross-2 {
    width: 2px;
    height: 9px;
    top: 1px;
    left: 4px;
    transform: rotate(-45deg);
  }

  .vertical-align-middle {
    vertical-align: middle;
  }
  .d-inline-flex {
    display: inline-flex;
  }
</style>
